import { Tab, Tabs } from "@blueprintjs/core";
import * as React from "react";

import { CustomDialog } from "../../components";
import { useCommonHooks } from "../../hooks";
import { ETLCodes } from "../../locales";
import { AvailabilityTab } from "./AvailabilityTab";
import { NotificationsTab } from "./NotificationsTab";
import { ProfileTab } from "./ProfileTab";

export interface IProfileDialogProps {
  isOpen: boolean;
  onClose: () => void;
  initialTab?: string;
}

export const ProfileDialog: React.FunctionComponent<IProfileDialogProps> = ({
  isOpen,
  onClose,
  initialTab = "profile",
}) => {
  const { t } = useCommonHooks();

  const [tab, setTab] = React.useState(initialTab);

  React.useEffect(() => {
    if (isOpen) setTab(initialTab);
  }, [initialTab, isOpen]);

  return (
    <CustomDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t(ETLCodes.MyProfile)}
      icon="user"
      width={1100}
      height="85vh"
      canEscapeKeyClose
      canOutsideClickClose
    >
      <Tabs
        selectedTabId={tab}
        renderActiveTabPanelOnly
        onChange={(nextTabId) => setTab(nextTabId + "")}
      >
        <Tab id="profile" title={t(ETLCodes.Profil)} panel={<ProfileTab />} />
        <Tab
          id="notifications"
          title={t(ETLCodes.Notifications)}
          panel={<NotificationsTab />}
        />
        <Tab
          id="availability"
          title={t(ETLCodes.Availability)}
          panel={<AvailabilityTab />}
        />
      </Tabs>
    </CustomDialog>
  );
};

export default ProfileDialog;
